// app.config.ts

/*
* @constant { object } AppConfig
*
* This object serves as the centralized configuration for the application.
*
* - 'defaultLanguage': Specifies the default language to be used across the application.
*    It acts as a fallback when the user's browser language cannot be determined or is not supported.
 */

export const AppConfig = {
    defaultLanguage: 'en'
}